import React, { Component } from 'react'
import './_styles.scss'
import { Button } from '../../../../packages/components'
import Translator from '../../../../requests/apa/Translator'
import Asset from '../../../../requests/apa/Asset'
import Utils from '../../../../utils/Utils'

class MainMenu extends Component {

    constructor (props) {
        super(props)
        this.state = { focusedIndex: null }
        this.items = this.props.items || []
        this.createItems = this.createItems.bind(this)
        this.handleContainerBlur = this.handleContainerBlur.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this._container = null
    }

    handleOnClick(index) {
        if (index > 0) {
            const brandHeader = document.querySelector('.brand-header')
            brandHeader && brandHeader.classList.add('brand-header__hide')
            this.props.onHeaderToggle && this.props.onHeaderToggle(false)
        }
        this.props.onItemClick && this.props.onItemClick(this.items[index].id)
    }

    handleFocusUp() {
        const brandHeader = document.querySelector('.brand-header')
        brandHeader && brandHeader.classList.remove('brand-header__hide')
        this.props.onHeaderToggle && this.props.onHeaderToggle(true)
    }

    handleContainerBlur(e) {
        const relatedTarget = e.relatedTarget
        if (relatedTarget && this._container && !this._container.contains(relatedTarget)) {
            const targetRect = relatedTarget.getBoundingClientRect()
            const containerRect = this._container.getBoundingClientRect()
            if (targetRect.bottom <= containerRect.top) {
                this.handleFocusUp()
            }
        }
    }

    handleKeyDown(e) {
        const UP_KEYS = ['ArrowUp', 'Up']
        const LEFT_KEYS = ['ArrowLeft', 'Left']
        const RIGHT_KEYS = ['ArrowRight', 'Right']
        const DOWN_KEYS = ['ArrowDown', 'Down']
        if (UP_KEYS.includes(e.key)) {
            this.handleFocusUp()
        } else if (LEFT_KEYS.includes(e.key)) {
            e.preventDefault()
            e.stopPropagation()
            const { focusedIndex } = this.state
            if (focusedIndex > 0 && this._container) {
                var buttons = this._container.querySelectorAll('.focusable')
                if (buttons[focusedIndex - 1]) buttons[focusedIndex - 1].focus()
            }
        } else if (RIGHT_KEYS.includes(e.key)) {
            e.preventDefault()
            e.stopPropagation()
            const { focusedIndex } = this.state
            if (focusedIndex < this.items.length - 1 && this._container) {
                var buttons = this._container.querySelectorAll('.focusable')
                if (buttons[focusedIndex + 1]) buttons[focusedIndex + 1].focus()
            }
        } else if (DOWN_KEYS.includes(e.key)) {
            e.preventDefault()
            e.stopPropagation()
            window.SpatialNavigation.focus('.main-content .focusable')
        }
    }

    createItems () {
        const { focusedIndex } = this.state
        const activeTab = this.props.activeTab
        return this.items && this.items.length > 0 && this.items.map((item, index) => {
            const isFocused = focusedIndex === index
            const isActive  = activeTab === item.id
            const title = Translator.get(item.title)
            const icon = Asset.get(item.icon)
            const iconHover = Asset.get(item.iconHover)
            return (
                <div className='main-menu__item' key={index}>
                    <Button
                        className='focusable'
                        onFocus={() => this.setState({ focusedIndex: index })}
                        onBlur={() => this.setState({ focusedIndex: null })}
                        onClick={() => this.handleOnClick(index)}
                    >
                        {
                            icon && (
                                <div className='main-menu__item-icon'>
                                    <img src={isFocused || isActive ? iconHover : icon} alt='' />
                                </div>
                            )
                        }
                        <div 
                            className={`main-menu__item-text${isActive ? ' main-menu__item-text--active' : ''}`} 
                            data-text={title}>
                                { Utils.cutPlayerString(title, 22) }
                        </div>
                    </Button>
                </div>
            )
        })
    }

    render () {
        return (
            <div className='main-menu' ref={(el) => { this._container = el }} onBlur={this.handleContainerBlur} onKeyDown={this.handleKeyDown}>
                <div className='main-menu__container'>
                    {this.createItems()}
                </div>
            </div>
        )
    }
}

export default MainMenu


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Components/MainMenu/index.jsx